import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=10ae12a4&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"
import style0 from "./Personal.vue?vue&type=style&index=0&id=10ae12a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae12a4",
  null
  
)

export default component.exports